import React from "react";
import clsx from 'clsx';
import { SvgIcon } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

const blockStyles = makeStyles(theme => ({
  root: {
    width: 72,
    height: 14
  }
}));

const MybilioTextBronze = (props) => {

  const classes = blockStyles();
  const { className } = props;

  return (
    <SvgIcon className = { clsx(classes.root, className) }
             titleAccess = 'Mybilio'
             viewBox = { "0 0 72 14" } >
      <path d="M32.5039 6.5046C33.2187 5.97404 33.6343 5.16161 33.6343 4.19996C33.6343 2.62485 32.5205 1.19896 30.2264 1.19896H27.0181V12.8051H30.8249C33.202 12.8051 34.4488 11.1636 34.4488 9.47245C34.4488 8.07972 33.6841 7.01859 32.5039 6.5046ZM30.1267 2.74091C31.3236 2.74091 32.0384 3.40412 32.0384 4.34919C32.0384 5.26109 31.307 6.02378 30.1101 6.02378H28.5973V2.74091H30.1267ZM30.7085 11.2631H28.5973V7.58231H30.7085C32.0384 7.58231 32.8031 8.37816 32.8031 9.40613C32.8031 10.4341 32.0218 11.2631 30.7085 11.2631Z" fill="#004876"/>
      <path d="M38.3234 12.8051H39.9027V1.19896H38.3234V12.8051Z" fill="#004876"/>
      <path d="M45.8995 11.2631V1.19896H44.3202V12.8051H50.205V11.2631H45.8995Z" fill="#004876"/>
      <path d="M53.4665 12.8051H55.0457V1.19896H53.4665V12.8051Z" fill="#004876"/>
      <path d="M65.0322 13.0206C68.6395 13.0206 71.0001 10.2351 71.0001 7.00201C71.0001 3.78546 68.6395 1 65.0322 1C61.4083 1 59.0477 3.78546 59.0477 7.00201C59.0477 10.2351 61.4083 13.0206 65.0322 13.0206ZM65.0322 11.4621C62.4057 11.4621 60.6602 9.37297 60.6602 7.00201C60.6602 4.63105 62.4057 2.55853 65.0322 2.55853C67.6421 2.55853 69.4208 4.63105 69.4208 7.00201C69.4208 9.37297 67.6421 11.4621 65.0322 11.4621Z" fill="#004876"/>
      <path d="M12.4961 12.8804L10.8753 5.37786L7.60021 13.0141H7.38299L4.15808 5.46141L2.63752 12.8804H1L3.57325 1H3.80718L7.49995 9.8894L11.176 1H11.41L14.1002 12.8804H12.4961Z" fill="#004876"/>
      <path d="M20.2236 8.71629V12.85H18.6401V8.74963L14.6731 1.18231H16.4566L19.4235 7.09949L22.4071 1.18231H24.1739L20.2236 8.71629Z" fill="#004876"/>
    </SvgIcon>
  );
}

export default MybilioTextBronze;
